import React, { Component } from 'react';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import KelasDropdown from '../masterDropDown/DropdownKelas';
import DropdownGuru from '../masterDropDown/DropdownGuru';
import Loader from '../../../Loader';

export default class ModalEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearch: true,
            idKelasParalel: '',
            idSekolah: '',
            idKelas: '',
            namaKelasParalel: '',
            idGuru: ''
        }
    }

    loading = () => {
        if(this.state.isSearch) {
            return(
                <Loader />
            )
        }
    }

    handleClickCloseModal = () => {
        this.props.onChange('isShowEdit', false);
        this.setState({
            isSearch: true,
            idKelasParalel: '',
            idSekolah: '',
            idKelas: '',
            namaKelasParalel: '',
            idGuru: ''
        });
    }

    onInputEditChange(event) {
        const fieldName = event.target.name;
        const fieldValue = event.target.value;
        
        this.setState({
            [fieldName]: fieldValue
        });
        this.props.onChange(fieldName, fieldValue);
    }
    
    componentWillReceiveProps(nextProps) {
        if (this.props.dataEdit !== nextProps.dataEdit) {
            this.setState({
                idKelasParalel: nextProps.dataEdit.idKelasParalel,
                idSekolah: nextProps.dataEdit.idSekolah,
                idKelas: nextProps.dataEdit.idKelas,
                namaKelasParalel: nextProps.dataEdit.namaKelasParalel,
                idGuru: nextProps.dataEdit.idGuru
            }, () => {
                this.props.onChange('idKelasParalel', this.state.idKelasParalel)
                this.props.onChange('idSekolah', this.state.idSekolah)
                this.props.onChange('idKelas', this.state.idKelas)
                this.props.onChange('namaKelasParalel', this.state.namaKelasParalel)
                this.props.onChange('idGuru', this.state.idGuru)
            }, this.setState({
                    isSearch: false
                })
            );
        }

        if(this.props.statusModal === false) {
            this.setState({
                isSearch: true,
                idKelasParalel: '',
                idSekolah: '',
                idKelas: '',
                namaKelasParalel: '',
                idGuru: ''
            });
        }
    }
    
    shouldComponentUpdate(nextProps, nextState) {
        if(this.props.kelasDropdown !== nextState.kelasDropdown) {
            return true;
        }

        if (this.props.guruDropdown !== nextState.guruDropdown) {
            return true;
        }
        
        return false;
    }
    
    render() {
        return(
                <>
                    {this.props.statusModal &&
                    <div className="modal fade show" id="editKelas" style={{display: 'block', paddingRight: '17px', backgroundColor: 'rgba(0,0,0,0.8)'}} aria-modal="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content"> 
                                <div className="modal-header">
                                    <h4 className="modal-title">Edit Kelas</h4>
                                    <button type="button" className="close" data-dismiss="modal" onClick={this.handleClickCloseModal}>&times;</button>
                                </div>
                                
                                <form id="form-tambah" onSubmit={this.props.eventSubmit}>
                                    <div className="modal-body">
                                        <input type="hidden" className="form-control" name="idKelasParalel" id="idKelasParalel" value={this.state.idKelasParalel}/>
                                        <div className="form-group">
                                            <label for="recipient-name" className="col-form-label">Kelas</label>
                                            <select className="form-control" name="idKelas" id="idKelas" value={this.state.idKelas} onChange={this.onInputEditChange.bind(this)}>
                                                <option value="" selected>-- Pilih Kelas --</option>
                                                <KelasDropdown kelas={this.props.kelasDropdown}/>
                                            </select>
                                        </div>
                                        
                                        <div className="form-group">
                                            <label for="recipient-name" className="col-form-label">Nama kelas Pararel</label>
                                            <input type="text" className="form-control" name="namaKelasParalel" id="namaKelasParalel" value={this.state.namaKelasParalel} onChange={this.onInputEditChange.bind(this)} placeholder="Nama Kelas Pararel" autoComplete="off"/>
                                        </div>

                                        <div className="form-group">
                                            <label for="label-wali-kelas" className="col-form-label">Wali Kelas</label>
                                            <select className="form-control" name="idGuru" id="idGuru" value={this.state.idGuru} onChange={this.onInputEditChange.bind(this)}>
                                                <option value="" selected>-- Pilih Wali Kelas --</option>
                                                <DropdownGuru guru={this.props.guruDropdown}/>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        {this.state.isSearch ?
                                            this.loading() :
                                            <>
                                                <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={this.handleClickCloseModal}>Batal</button>
                                                <button type="submit" className="btn btn-primary">Simpan</button>
                                            </>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }
}